import { LocaleInput } from '../index.js'

export default {
  code: 'tr',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 7, // The week that contains Jan 1st is the first week of the year.
  },
  buttonText: {
    prev: 'geri',
    next: 'ileri',
    today: 'bugün',
    month: 'Ay',
    week: 'Hafta',
    day: 'Gün',
    list: 'Ajanda',
  },
  weekText: 'Hf',
  allDayText: 'Tüm gün',
  moreLinkText: 'daha fazla',
  noEventsText: 'Gösterilecek etkinlik yok',
} as LocaleInput
